var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',_vm._b({attrs:{"label":_vm.$t('Use Rates at Checkout'),"hide-details":"auto"},model:{value:(_vm.liveRates),callback:function ($$v) {_vm.liveRates=$$v},expression:"liveRates"}},'switch-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }